import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'semantic-ui-react';
import Link from '../../atoms/Link';
import { isExternalPage } from '../../services/pages';

export default class SiteMap extends React.Component {
  render() {
    const { links, horizontal, bulleted } = this.props;
    return (
      <List horizontal={horizontal} bulleted={bulleted}>
        {links.map(({ title, pageType, slug, url, contentProps }, index) => {
          return (
            <List.Item key={title}>
              <List.Content>
                <Link
                  to={isExternalPage(pageType) ? url : slug}
                  linkAs="span"
                  title={title}
                  internal={!isExternalPage(pageType)}
                  contentProps={contentProps}
                />
              </List.Content>
            </List.Item>
          );
        })}
      </List>
    );
  }
}

SiteMap.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      pageTitle: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      internal: PropTypes.bool,
      className: PropTypes.string,
    }),
  ).isRequired,
  bulleted: PropTypes.bool,
  horizontal: PropTypes.bool,
};

SiteMap.defaultProps = {
  bulleted: false,
  internalLinkComponent: null,
  horizontal: false,
};
